module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "companies active",
    attrs: {
      "to": {
        name: 'default-email-templates'
      }
    }
  }, [_vm._v("Email templates")])], 1), _vm._v(" "), _c('div', {
    staticClass: "industry-emails"
  }, [_c('div', {
    staticClass: "industry-emails-container"
  }, [_c('div', {
    staticClass: "industry-emails-menu"
  }, [(_vm.emailTemplates) ? _c('div', [_c('div', {
    staticClass: "section-head"
  }, [_vm._v("\n            Email templates\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._l((_vm.emailTemplates), function(item) {
    return _c('router-link', {
      key: item.value,
      staticClass: "section-item",
      class: {
        'active': _vm.template === item.value
      },
      attrs: {
        "to": {
          name: 'default-email-templates',
          query: {
            template: item.value
          }
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "industry-emails-content"
  }, [_c('div', {
    ref: "templateDetails",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTemplate === false) ? [_vm._v(_vm._s(_vm.templateLabel) + " email")] : [_vm._v("Edit \"" + _vm._s(_vm.templateLabel) + "\" email")]], 2), _vm._v(" "), _c('div', {
    staticClass: "content-section-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.emailTemplate.description))]), _vm._v(" "), _c('p', {
    staticClass: "variables-list"
  }, [_vm._v("\n                It supports the following variables:\n              ")]), _vm._v(" "), _c('dl', [_vm._l((_vm.emailTemplate.variables), function(variable, index) {
    return [_c('dt', [_c('code', [_vm._v("[" + _vm._s(variable) + "]")])]), _vm._v(" "), (index !== Object.keys(_vm.emailTemplate.variables).length - 1) ? _c('dt', {
      staticClass: "code-separator"
    }) : _vm._e()]
  })], 2)]), _vm._v(" "), (_vm.canEditTemplate === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditTemplate()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "templatePreview",
    staticClass: "content-section content-section__bordered border-1-20",
    class: {
      'content-section__no_padding': _vm.canEditTemplate === false
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditTemplate === false),
      expression: "canEditTemplate === false"
    }]
  }, [_c('div', {
    attrs: {
      "id": "emailBody"
    }
  })]), _vm._v(" "), (_vm.canEditTemplate === true) ? _c('article', {
    staticClass: "personal-info"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-subject"
    }
  }, [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTemplate.email.subject),
      expression: "emailTemplate.email.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Subject')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTemplate === false,
      "data-lpignore": "true",
      "id": "template-subject",
      "name": "Subject"
    },
    domProps: {
      "value": (_vm.emailTemplate.email.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailTemplate.email, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Subject')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Subject')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTemplate.email.title),
      expression: "emailTemplate.email.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTemplate === false,
      "data-lpignore": "true",
      "id": "template-title",
      "name": "Title"
    },
    domProps: {
      "value": (_vm.emailTemplate.email.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailTemplate.email, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Title')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "template-body"
    }
  }, [_vm._v("Email body")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "article-editor",
    attrs: {
      "id": "template-body",
      "editorToolbar": _vm.editorToolbar,
      "name": "body"
    },
    model: {
      value: (_vm.emailTemplate.email.body),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate.email, "body", $$v)
      },
      expression: "emailTemplate.email.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTemplate) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTemplate()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailTemplate()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "testTemplate",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Send test email\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "email-address"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testEmail.email),
      expression: "testEmail.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "email-address",
      "name": "Email address"
    },
    domProps: {
      "value": (_vm.testEmail.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testEmail, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                  " + _vm._s(this.errors.first('Email address')) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendTestEmail()
      }
    }
  }, [_vm._v("Send")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [_vm._v("\n      Default email templates\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef4ec024","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EditDefaultEmails.vue
// module id = 999
// module chunks = 1